import http from "../httpService";
import {getBaseUrl} from "../../config";

;


export const getServiceActivity = id => {
  return http.get(
    `${getBaseUrl()}/serviceـactivity/${id}`
  );
};

export const getServiceActivities = (id) => {
  return http.get(
    `${getBaseUrl()}/service_activities/${id}`
  );
};

export const updateServiceActivity = data => {

  return http.put(
    `${getBaseUrl()}/serviceـactivity/${data.id}`,
    data
  );
};
export const submitServiceActivity = data => {
  http.hasFile();
  return http.post(
    `${getBaseUrl()}/service_activity`,
    data
  );
};
